var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoad2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 22,
    viewBox: "0 0 38 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.43 15.7599C11.8 13.8999 6.16 12.0399 0.559998 10.1499C2.63 7.57994 3.86 4.32994 3.86 0.779938V0.689941C9.4 2.56994 14.99 4.41994 20.57 6.25994C26.2 8.11994 31.84 9.97994 37.44 11.8699C35.37 14.4399 34.14 17.6899 34.14 21.2399V21.3299C28.6 19.4499 23.01 17.5999 17.43 15.7599Z",
    fill: "#DDDDDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoad2);
export default __webpack_public_path__ + "static/media/road_2.5afd4bd6e4ecfeeb27a026120cd11dbc.svg";
export { ForwardRef as ReactComponent };